import { render, staticRenderFns } from "./team-goal-categories.vue?vue&type=template&id=1a11351d&scoped=true&"
import script from "./team-goal-categories.vue?vue&type=script&lang=js&"
export * from "./team-goal-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11351d",
  null
  
)

export default component.exports